import React, { useState, useEffect } from 'react'
import Formulario from 'components/formulario';
import { Cancel, Search } from '@mui/icons-material';
import { obtenerRegistrosPersonalizado, obtenerRegistrosPersonalizadoPublic } from 'store/actions/customAction';
import { alertaPersonalizadaSwal } from 'servicios/AlertasPersonalizados';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import { useDispatch, useSelector } from 'react-redux';
import ServiciosDelAPI from 'servicios/ServiciosDelAPI';
import { nombreDeAcciones } from 'constantes';

let datosDeEmpresas = [];
let fechasDeOrdenesGlobal = [];
export default function Buscador({buscarFiltro, tamanioInput, salirDelFiltro}) {
  const dispatch = useDispatch();
  const {datosGenerales} = useSelector((state) => state);
  const[cargandoSolicitud, setcargandoSolicitud] = useState(false);
  const [registrosDePlanDeMedios] = useState("registrosDePlanDeMedios");
  const [catalogoDeMediosPublicos] = useState("catalogoDeMediosPublicos");
  const [ordenesDeTransmision] = useState("ordenesDeTransmision");

  useEffect(() => {
    obtenerFechasDeOrdenes();
  }, []);

  const obtenerFechasDeOrdenes = async () => {
    const copiaDeCampos = Object.assign({}, camposDelFormulario);
    copiaDeCampos.fechaDeOrdenes.value = null;

    setcargandoSolicitud(true);

    let respuesta = await dispatch(obtenerRegistrosPersonalizado({
      controller: ordenesDeTransmision,
      validateIfDataExists: true,
      nombreDelMetodo: `listar/fechasDeOrdenes` ,
      stateInStore: datosGenerales.fechasDeOrdenes,
      dispatchAction: nombreDeAcciones.SETEAR_FECHAS_ORDENES,
    }));

    setcargandoSolicitud(false);

    if(respuesta?.error) return alertaPersonalizadaSwal( respuesta?.error?.message || 'No se pudieron obtener los medios de comunicación');

    if(respuesta?.data?.length === 0) return alertaPersonalizadaSwal('No se encontraron datos de rango de fechas');

    fechasDeOrdenesGlobal = respuesta.data;
    copiaDeCampos.fechaDeOrdenes.list = respuesta?.data?.map( ({id, fechaInicio, fechaFinal}) => ({id, name: `${fechaInicio} - ${fechaFinal}`}) );

    setCamposDelFormulario(copiaDeCampos);
  }

  const manejadorBuscarMedioComunicacion = async () => {
    const copiaDeCampos = Object.assign({}, camposDelFormulario);
    const {nivelDeCobertura, tipoDeMedio} = camposDelFormulario;
    copiaDeCampos.corporacion.value = null;

    setcargandoSolicitud(true);
    ServiciosDelAPI[catalogoDeMediosPublicos].setearMetodoPublico(true);
    let respuesta = await dispatch(obtenerRegistrosPersonalizadoPublic({
        controller: catalogoDeMediosPublicos,
        saveInStore: false,
        nombreDelMetodo: `listar/filtarEmpresasCuandoExistaTipoDeMedioYTipoDeCobertura/${nivelDeCobertura?.value?.id || 0}/${tipoDeMedio?.value?.id || 0}` ,
    }));

    setcargandoSolicitud(false);

    if(respuesta?.error) return alertaPersonalizadaSwal( respuesta?.error?.message || 'No se pudieron obtener los medios de comunicación');

    if(respuesta?.data?.length === 0) return alertaPersonalizadaSwal('No se encontraron medios de comunicación para este tipo de cobertura y tipo de medio');

    datosDeEmpresas = respuesta.data;
    copiaDeCampos.corporacion.list = respuesta?.data?.map( ({nit, nombreEmpresa}) => ({id: nit, name: nombreEmpresa}) )

    setCamposDelFormulario(copiaDeCampos);
  }


  // const manejadorBuscarMedioComunicacion2 = async () => {
  //   const copiaDeCampos = Object.assign({}, camposDelFormulario);

  //   const {nivelDeCobertura, tipoDeMedio} = camposDelFormulario;
  //   copiaDeCampos.corporacion.value = null;

  //   setcargandoSolicitud(true);
  //   let respuesta = await dispatch(obtenerRegistrosPersonalizado({
  //       controller: registrosDePlanDeMedios,
  //       saveInStore: false,
  //       nombreDelMetodo: `listar/medios/${tipoDeMedio?.value?.id || 0}/${nivelDeCobertura?.value?.id || 0}` ,
  //   }));

  //   setcargandoSolicitud(false);

  //   if(respuesta?.error) return alertaPersonalizadaSwal( respuesta?.error?.message || 'No se pudieron obtener los medios de comunicación');

  //   if(respuesta?.data?.length === 0) return alertaPersonalizadaSwal('No se encontraron medios de comunicación para este tipo de cobertura y tipo de medio');

  //   datosDeEmpresas = respuesta.data;
  //   copiaDeCampos.corporacion.list = respuesta?.data?.map( ({nit, empresa}) => ({id: nit, name: empresa?.nombreEmpresa}) )
  //   setCamposDelFormulario(copiaDeCampos);
  // }

  const [camposDelFormulario, setCamposDelFormulario] = useState({
    tipoDeCandidatura: {
      idelement: "tipoDeCandidatura", value: null, label: "Tipo de candidatura *", pattern:"^[1-9][0-9]*$", validators: ['required'],
      errorMessages:['Seleccione una opción'], isError:false, showSelectAutoComplete: true, elementType:'autoCompletar', list: [{id: 1, name: "PRESIDENTE"}, {id: 2, name: "CORPORACIONES MUNICIPALES"}, {id: 3, name: "DIPUTACIONES"}], handler: undefined, width: tamanioInput
    },
    nivelDeCobertura: {
      idelement: "nivelDeCobertura", value: null, label: "Nivel de cobertura *", pattern:"^[1-9][0-9]*$", validators: ['required'],
      errorMessages:['Seleccione una opción'], isError:false, showSelectAutoComplete: true, elementType:'autoCompletar', list: [{id: 1, name: "NACIONAL"}, {id: 2, name: "REGIONAL"}, {id: 3, name: "DEPARTAMENTAL"}, {id: 4, name: "MUNICIPAL"}], handler: undefined, width: tamanioInput
    },
    tipoDeMedio: {
      idelement: "tipoDeMedio", value: null, label: "Tipo de medio *", pattern:"^[1-9][0-9]*$", validators: ['required'],
      errorMessages:['Seleccione una opción'], isError:false, showSelectAutoComplete: true, elementType:'autoCompletar', list: [{id: 1, name: "TELEVISION"}, {id: 2, name: "RADIO"}, {id: 3, name: "ESCRITOS"}], handler: manejadorBuscarMedioComunicacion, width: tamanioInput
    },
    corporacion: {
      idelement: "corporacion", value: null, label: "Medio de comunicación *", pattern:"^[0-9A-Za-z-ñÑ]*$", validators: ['required'],
      errorMessages:['Seleccione una opción'], isError:false, showSelectAutoComplete: true, elementType:'autoCompletar', list: [], handler: undefined, width: tamanioInput
    },
    fechaDeOrdenes: {
      idelement: "fechaDeOrdenes", value: null, label: "Rango de fechas *", pattern:"^[0-9A-Za-z-ñÑ]*$", validators: ['required'],
      errorMessages:['Seleccione una opción'], isError:false, showSelectAutoComplete: true, elementType:'autoCompletar', list: [], handler: undefined, width: tamanioInput
    },
  });

  const [listadoBotones2]= useState({
    "saveData":{"label":"Buscar", "icon": <Search />, "callback":buscarFiltro, "loading":false, "size":"medium", "background":"linear-gradient(45deg, #205690 30%, #3890EE 90%)", "border":"0px", "borderRadius":"3", "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", color:"white", "height":37, padding:"0 30px", disabled: false, isCancel: false,
    },
    "salirDelFiltro":{"label":"Salir", "icon": <Cancel />,"callback":salirDelFiltro,"loading":false,"size":"medium",
      "background":"linear-gradient(45deg, #B90000 30%, #E07777 90%)", "border":"0px", "borderRadius":"3",
      "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",  disabled: false,
      isCancel: true,
      },
  });

  return (
    <>
      {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
      <Formulario
        elements={camposDelFormulario}
        buttonList={listadoBotones2}
      />
    </>
  )
}

Buscador.defaultProps = {
  tamanioInput: '50%',
}